export default __webpack_public_path__ + "static/media/image.adlux-software-pvt-ltd.07a08f98.png";